import LegalPageLayout from "@/components/landing/LegalPageLayout";

const PrivacyPolicy = () => (
  <LegalPageLayout title="Privacy Policy" lastUpdated="January 15, 2026">
    <section>
      <h2>1. Introduction</h2>
      <p>
        Trust Wallet Card ("we," "our," or "us") is a decentralized service committed to user privacy. This Privacy Policy explains our approach to data and privacy when you use our services.
      </p>
    </section>

    <section>
      <h2>2. Minimal Data Collection</h2>
      <p>
        As a decentralized platform, we do not collect personal identification information. We do not require your name, address, government ID, or any other personal documents. The only data associated with your account is your public wallet address, which is already publicly available on the blockchain.
      </p>

      <h3>Technical Information</h3>
      <p>We may collect minimal technical data to ensure service functionality:</p>
      <ul>
        <li>Browser type and operating system (anonymized)</li>
        <li>Language and region preferences</li>
        <li>General usage patterns (aggregated and anonymized)</li>
      </ul>
    </section>

    <section>
      <h2>3. How We Use Information</h2>
      <ul>
        <li>Facilitating cryptocurrency-to-fiat conversions at the point of sale</li>
        <li>Calculating and distributing crypto rewards</li>
        <li>Improving our services and user experience</li>
        <li>Ensuring platform security and preventing unauthorized access</li>
      </ul>
    </section>

    <section>
      <h2>4. No Data Sharing</h2>
      <p>
        We do not share, sell, or disclose any user data to third parties. Since we do not collect personal information, there is nothing to share. Transaction data exists on the blockchain and is publicly verifiable.
      </p>
    </section>

    <section>
      <h2>5. Data Security</h2>
      <p>
        We implement industry-leading security measures including encryption, secure infrastructure, and regular security audits by CertiK. Our non-custodial design means your funds remain in your wallet at all times.
      </p>
    </section>

    <section>
      <h2>6. No Data Retention</h2>
      <p>
        Since we do not collect personal data, there is no personal information stored on our servers. Technical logs are automatically purged after 30 days.
      </p>
    </section>

    <section>
      <h2>7. Your Rights</h2>
      <p>
        You have full control over your data at all times. Since our service is non-custodial and decentralized, you can disconnect your wallet and stop using the service at any point with no data left behind.
      </p>
    </section>

    <section>
      <h2>8. Contact Us</h2>
      <p>
        For privacy-related inquiries, please contact us through the Trust Wallet app or via our Help Center.
      </p>
    </section>
  </LegalPageLayout>
);

export default PrivacyPolicy;
